import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Card, CardContent } from '../components/ui/Card';
function RichTextEditor({
  label,
  defaultValue = '',
  highlighted = false
}: {
  label: string;
  defaultValue?: string;
  highlighted?: boolean;
}) {
  return <div data-id="element-568">
      <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-569">
        {label}
      </label>
      <div className="border border-slate-300 rounded-md overflow-hidden" data-id="element-570">
        {/* Toolbar row 1 */}
        <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-571">
          <button type="button" className="px-1.5 py-0.5 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-572">
            Source
          </button>
          <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-573" />
          {['📄', '📋', '✂', '🗑', '↩', '↪'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-574">
              {ic}
            </button>)}
          <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-575" />
          {['🔍', '🔤', '🖊'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-576">
              {ic}
            </button>)}
        </div>
        {/* Toolbar row 2 */}
        <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-577">
          {['B', 'I', 'U', 'S'].map(t => <button key={t} type="button" className="w-6 h-6 text-xs font-bold border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-700" data-id="element-578">
              {t}
            </button>)}
          <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-579" />
          {['≡', '≣', '❝', '»'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-580">
              {t}
            </button>)}
          <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-581" />
          <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-582">
            <option data-id="element-583">Styles</option>
          </select>
          <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-584">
            <option data-id="element-585">Format</option>
          </select>
          <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-586">
            <option data-id="element-587">Font</option>
          </select>
          <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-588">
            <option data-id="element-589">Size</option>
          </select>
          <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-590" />
          {['A', 'A', '⊞', '⊟', '⊕', '?'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-591">
              {t}
            </button>)}
        </div>
        {/* Editor area */}
        <textarea className={`w-full p-3 text-sm focus:outline-none resize-y min-h-[140px] ${highlighted ? 'bg-pink-50' : 'bg-white'}`} defaultValue={defaultValue} data-id="element-592" />
      </div>
    </div>;
}
const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const days = Array.from({
  length: 31
}, (_, i) => String(i + 1));
const years = Array.from({
  length: 10
}, (_, i) => String(2026 - i));
const hours = Array.from({
  length: 12
}, (_, i) => String(i + 1));
const minutes = Array.from({
  length: 60
}, (_, i) => String(i).padStart(2, '0'));
const fullDescDefault = `SECTION 3: More Clauses and Contingencies

Most purchase contracts for residential real estate will allow both parties time to review certain documents to determine their desire to move forward. While the seller typically has limited review options, the buyer is often allowed a pre-determined period to review numerous items, including but not limited to:

• Finance options
• Community and homeowner's association documents
• Title and escrow procedures
• Insurance options and possible obligations (such as flood insurance)
• Property condition and issues included value, zoning, land use, etc.`;
export function EditCourseSection() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;
  return <div className="space-y-4" data-id="element-593">
      <div className="flex items-center justify-between" data-id="element-594">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-595">
          {isEdit ? 'Edit Section' : 'Add Section'}
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/sections')} data-id="element-596">
          ← Back to Sections
        </Button>
      </div>

      <Card data-id="element-597">
        <CardContent className="pt-6" data-id="element-598">
          <form className="space-y-5 max-w-2xl" data-id="element-599">
            <Input label="Name" defaultValue={isEdit ? 'Section 3' : ''} className="max-w-xs" data-id="element-600" />

            <RichTextEditor label="Small Description" defaultValue="" data-id="element-601" />

            <RichTextEditor label="Full Description" defaultValue={isEdit ? fullDescDefault : ''} highlighted={isEdit} data-id="element-602" />

            {isEdit && <div data-id="element-603">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-604">
                  Bg Color
                </label>
                <input type="text" defaultValue="#FCCCC" className="h-8 w-32 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-605" />
              </div>}

            <div data-id="element-606">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-607">
                Question Types
              </label>
              <select defaultValue="Multiple" className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-608">
                <option value="Multiple" data-id="element-609">Multiple</option>
                <option value="TrueFalse" data-id="element-610">True/False</option>
                <option value="Essay" data-id="element-611">Essay</option>
              </select>
            </div>

            <div data-id="element-612">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-613">
                Required Time
              </label>
              <input type="text" defaultValue={isEdit ? '25' : ''} className="h-8 w-24 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-614" />
            </div>

            <div data-id="element-615">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-616">
                Position
              </label>
              <input type="text" defaultValue="" className="h-8 w-24 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-617" />
            </div>

            {isEdit && <div data-id="element-618">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-619">
                  Created
                </label>
                <div className="flex items-center gap-1 flex-wrap" data-id="element-620">
                  <select defaultValue="June" className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-621">
                    {months.map(m => <option key={m} data-id="element-622">{m}</option>)}
                  </select>
                  <select defaultValue="30" className="h-8 w-16 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-623">
                    {days.map(d => <option key={d} data-id="element-624">{d}</option>)}
                  </select>
                  <select defaultValue="2025" className="h-8 w-20 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-625">
                    {years.map(y => <option key={y} data-id="element-626">{y}</option>)}
                  </select>
                  <select defaultValue="2" className="h-8 w-14 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-627">
                    {hours.map(h => <option key={h} data-id="element-628">{h}</option>)}
                  </select>
                  <select defaultValue="49" className="h-8 w-16 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-629">
                    {minutes.map(m => <option key={m} data-id="element-630">{m}</option>)}
                  </select>
                  <select defaultValue="pm" className="h-8 w-16 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-631">
                    <option value="am" data-id="element-632">am</option>
                    <option value="pm" data-id="element-633">pm</option>
                  </select>
                </div>
              </div>}

            <div className="pt-2" data-id="element-634">
              <Button type="submit" data-id="element-635">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}